import { __extends } from "tslib";
import React from 'react';
var FileUrl = /** @class */ (function (_super) {
    __extends(FileUrl, _super);
    function FileUrl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            url: null,
        };
        return _this;
    }
    FileUrl.prototype.componentDidMount = function () {
        this.setState({
            url: URL.createObjectURL(this.props.file),
        });
    };
    FileUrl.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.file !== this.props.file) {
            URL.revokeObjectURL(this.state.url);
            this.setState({
                url: URL.createObjectURL(this.props.file),
            });
        }
    };
    FileUrl.prototype.componentWillUnmount = function () {
        URL.revokeObjectURL(this.state.url);
    };
    FileUrl.prototype.render = function () {
        return this.props.children(this.state.url);
    };
    return FileUrl;
}(React.Component));
export default FileUrl;
//# sourceMappingURL=FileUrl.js.map